<!-- 推送商城商品 -->
<template>
    <div id="push">
        <div class="push-title">
            在线客户列表
        </div>
        <div>
            <div class="customer-item" @click="push(item)" v-for="item in tableData">
                {{item.uName}}
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: '',
        props:{
            goodMsg:Object,
        },
        components: {

        },
        data(){
            return {
                tableData:[],
                tableDataLength:[]
            }
        },
        mounted(){
            this.getTableData()
        },
        methods:{
            // 推送商城商品
            push(item){
                let pushMsg = {
                    customerMsg:item,
                    goodMsg:this.goodMsg
                }
                this.$store.commit('updatePushShopGoodMsg',pushMsg)
                this.$message({
                    message: '商品已推送',
                    type: 'success'
                });
                this.$emit('closeDialog')
            },
            // 加载顾客列表
            getTableData(){
                this.tableData = this.$store.state.chatingList
            },
        }
    }
</script>
<style lang="less" scoped>
    .push-title{
        font-size: @font-sm;
        font-weight: bold;
        margin-bottom: 20px;
        padding-left: 10px;
    }
    .customer-item {
        cursor: pointer;
        padding: 10px;
        border-bottom: 1px solid @border4Color;
        &:hover {
            background: @border4Color;
        }
    }
</style>
